export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      width: 120,
    },{
      label: '背景图预览',
      width: 100,
      prop: 'backgroundImage',
      overHidden: true,
      solt: true,
    },
	  {
      label: '名称',
      prop: 'name',
      width: 320,
      overHidden: true,
    },
    {
      label: '类型',
      prop: 'type',
      width: 120,
      solt: true,
    },
    {
      label: '状态',
      prop: 'isActive',
      width: 120,
      solt: true,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 180,
    },
    {
      label: '创建人',
      prop: 'creator',
    },
  ]
}

export const certRecordOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: '员工号',
      prop: 'unionId',
      width: 180,
    },
    {
      label: '用户名',
      prop: 'memberName',
      width: 180,
    },
	  {
      label: '证书名',
      prop: 'certName',
      width: 180,
      solt: true,
    },
	  {
      label: '获得时间',
      prop: 'issueDate',
      width: 180,
    },
	  {
      label: '获得原因',
      prop: 'issueComments',
      width: 180,
    },
    {
      label: '状态',
      prop: 'isActive',
      solt: true,
    },
  ]
}

export const childCertTypeOptions = [
  { label: '线上培训', value: 1 }, 
  { label: '线下活动', value: 2 }, 
  { label: '考试', value: 3 }, 
  { label: '其他', value: 0 }, 
]

export const childCertStatusOptions = [
  { label: '开启发放', value: true }, 
  { label: '停止发放', value: false }, 
]
